import { useEffect, useRef, useState } from 'react'

import {
  getExtraItemIds,
  loadExtra,
} from './useRequestLoadExtraTableData.utils'

export function useRequestLoadExtraTableData(items) {
  const [extra, setExtra] = useState(null)

  const isReloadScheduledRef = useRef(false)
  const lastLoadIdRef = useRef(0)

  const itemIds = getExtraItemIds(items)

  // No rows, nothing to load: a call scheduled for none would swallow the
  // reload that the rows bring in the same tick.
  function handleReloadExtra() {
    if (itemIds && !isReloadScheduledRef.current) {
      isReloadScheduledRef.current = true

      lastLoadIdRef.current += 1

      const loadId = lastLoadIdRef.current

      // One profile action can trigger several reload callbacks in the same
      // tick, so the load is deferred to a microtask to collapse them into a
      // single request
      Promise.resolve().then(() => {
        isReloadScheduledRef.current = false

        loadExtra(items)?.then(data => {
          if (loadId === lastLoadIdRef.current) {
            setExtra(data)
          }
        })
      })
    }
  }

  useEffect(() => {
    handleReloadExtra()
  }, [itemIds])

  return { extra, handleReloadExtra }
}
